import { type Song } from '../types';

export const categories = [
  'Songs referenced in Glass Onion',
  'Songs with only one Beatle',
  'Songs in the Yellow Submarine film',
  "Songs with person's name in title",
  'Songs over 4 minutes',
  'Ringo lead vocal',
  'Album openers',
  'Album closers',
  "John Lennon isn't on it",
  'UK number 1 single',
  'B-side of UK single',
  'Not Lennon—McCartney',
  'George lead vocal',
  'No percussion',
  'George Martin plays piano',
  'Number(s) in title',
  'Side A, Track 2',
  'Side A, Track 3',
  'Side A, Track 4',
  'Side A, Track 5',
  'Under 2 minutes',
  'Released 1963',
  'Released 1964',
  'Released 1965',
  'Released 1966',
  'Released 1967',
  'Released 1968',
  'Released 1969',
  'Released 1970',
  'Songs with colours in lyrics',
  'Songs that mention real public figures by name',
  'Songs with an Indian instrument',
  'Songs that begin with a count-in',
  'Paul plays the drums',
  'Shares name with Beatle film',
  '2 word title',
  '3 word title',
  '1 word title',
  "The Beatles aren't playing instruments",
  'Verb in the title',
  'More than one time signature',
  '“You” in the title',
  'Word(s) repeat in title',
  '“Love”, “Loving”, “Loves” in the title',
  'Peaked at 2 in UK singles chart',
  'Features brass instruments',
  'Cover version by another artist got into the UK singles chart top 10',
  'The Beatles played it on tour or in a live performance',
  'Real place named in lyrics',
  'Food / meals / drink in lyrics',
  'Not about love/not about romantic relationships',
  'Animal in lyrics',
  'Appears on Meet  The Beatles! (album in North America)',
  'Appears on Yesterday and Today (album in North America)',
  'Jewellery or items of clothing in lyrics',
  'A-Side of a UK single (1962-1970) that also appears on a UK studio album',
  'Weather mentioned in lyrics',
  "In Rolling Stone's 500 Greatest Songs of All Time list, 2004 version",
  'Features a harmonica',
  'The word "baby" or "babe" in the lyrics',
  'Days of the week in the lyrics',
  'Lyrics that refer to the telephone',
  '"Heart" in the lyrics',
  'The words "head(s)", "shoulder(s)", "knee(s)" or "toe(s)" in lyrics',
  'Billy Preston plays on it',
  'All four Beatles (and no one else) on the recording',
  'Body of water in the lyrics',
  "The full song title isn't in the lyrics",
  'Features orchestral strings',
  'The word "boy" in the lyrics',
  'The word "girl" in the lyrics',
  'The word "face" in the lyrics',
  'The word "eye(s)" in the lyrics',
  'Features either a mellotron or a synthesiser',
  'Features either a harmonium or a harpsichord/clavichord',
  'The word "song(s)" in the lyrics',
  'The word "money" in the lyrics',
  'The word "mother" in the lyrics',
  'Modes of transport referred to in the lyrics',
  'Number 1 in the US (Billboard Hot 100) but never number 1 in the UK singles chart',
  'Opens Side Two on a UK studio album',
  'John and Paul both singing lead vocals',
  'Wings played it live on tour',
] as const;

export type Category = (typeof categories)[number];

export type CategoriesWithAnswers = Record<Category, Song[]>;

export const categoriesWithAnswers: CategoriesWithAnswers = {
  'Songs referenced in Glass Onion': [
    'Fixing A Hole',
    'I Am The Walrus',
    'Lady Madonna',
    'Strawberry Fields Forever',
    'The Fool On The Hill',
  ],
  'Songs with only one Beatle': [
    'Blackbird',
    'Good Night',
    'Her Majesty',
    'Julia',
    'Martha My Dear',
    "Mother Nature's Son",
    'Wild Honey Pie',
    'Within You Without You',
    'Yesterday',
  ],
  'Songs in the Yellow Submarine film': [
    'A Day In The Life',
    'All Together Now',
    'All You Need Is Love',
    "Baby You're A Rich Man",
    'Eleanor Rigby',
    'Hey Bulldog',
    "It's All Too Much",
    'Love You To',
    'Lucy In The Sky With Diamonds',
    'Nowhere Man',
    'Only A Northern Song',
    "Sgt Pepper's Lonely Hearts Club Band",
    'Think For Yourself',
    "When I'm Sixty-Four",
    'With A Little Help From My Friends',
    'Yellow Submarine',
  ],
  "Songs with person's name in title": [
    'Being For The Benefit Of Mr Kite!',
    'Dear Prudence',
    'Eleanor Rigby',
    'Hey Jude',
    'Julia',
    'Lady Madonna',
    'Lovely Rita',
    'Martha My Dear',
    "Maxwell's Silver Hammer",
    'Michelle',
    'Polythene Pam',
    'Sexy Sadie',
    "Sgt Pepper's Lonely Hearts Club Band",
    "Sgt Pepper's Lonely Hearts Club Band (Reprise)",
    'The Ballad Of John And Yoko',
    'The Continuing Story Of Bungalow Bill',
    'Rocky Raccoon',
    'Mean Mr Mustard',
    'Doctor Robert',
    'Lucy In The Sky With Diamonds',
    'Polythene Pam',
  ],
  'Songs over 4 minutes': [
    'A Day In The Life',
    'Come Together',
    'Free As A Bird',
    'Helter Skelter',
    'Hey Jude',
    'I Am The Walrus',
    "I Want You (She's So Heavy)",
    "It's All Too Much",
    'Let It Be',
    'Now And Then',
    'Revolution 1',
    'Revolution 9',
    'Strawberry Fields Forever',
    'While My Guitar Gently Weeps',
    'Within You Without You',
    'Yer Blues',
    'You Know My Name (Look Up The Number)',
    'You Never Give Me Your Money',
  ],
  'Ringo lead vocal': [
    "Don't Pass Me By",
    'Good Night',
    'I Wanna Be Your Man',
    "Octopus's Garden",
    'What Goes On',
    'With A Little Help From My Friends',
    'Yellow Submarine',
  ],
  'Album openers': [
    "A Hard Day's Night",
    'Back In The USSR',
    'Come Together',
    'Drive My Car',
    'Help!',
    'I Saw Her Standing There',
    "It Won't Be Long",
    'Magical Mystery Tour',
    'No Reply',
    "Sgt Pepper's Lonely Hearts Club Band",
    'Taxman',
    'Two Of Us',
    'Yellow Submarine',
  ],
  'Album closers': [
    'A Day In The Life',
    'All You Need Is Love',
    'Get Back',
    'Good Night',
    'Her Majesty',
    "I'll Be Back",
    'Run For Your Life',
    'The End',
    'Tomorrow Never Knows',
  ],
  "John Lennon isn't on it": [
    'Blackbird',
    "Don't Pass Me By",
    'For No One',
    'Good Night',
    'Her Majesty',
    'Here Comes The Sun',
    'I Me Mine',
    'Long, Long, Long',
    'Love You To',
    'Martha My Dear',
    "Mother Nature's Son",
    "Why Don't We Do It In The Road?",
    'Wild Honey Pie',
    'Within You Without You',
    'Yesterday',
    "Maxwell's Silver Hammer",
    'Golden Slumbers',
    'Carry That Weight',
  ],
  'UK number 1 single': [
    "A Hard Day's Night",
    'All You Need Is Love',
    "Can't Buy Me Love",
    'Day Tripper',
    'Eleanor Rigby',
    'From Me To You',
    'Get Back',
    'Hello, Goodbye',
    'Help!',
    'Hey Jude',
    'I Feel Fine',
    'I Want To Hold Your Hand',
    'Lady Madonna',
    'Now And Then',
    'Paperback Writer',
    'She Loves You',
    'The Ballad Of John And Yoko',
    'Ticket To Ride',
    'We Can Work It Out',
    'Yellow Submarine',
  ],
  'B-side of UK single': [
    'Ask Me Why',
    "Baby You're A Rich Man",
    "Baby's In Black",
    'Christmas Time (Is Here Again)',
    "Don't Let Me Down",
    'I Am The Walrus',
    "I'll Get You",
    "I'm Down",
    'PS I Love You',
    'Rain',
    'Revolution',
    "She's A Woman",
    'Thank You Girl',
    'The Inner Light',
    'Things We Said Today',
    'This Boy',
    'Yes It Is',
    'You Know My Name (Look Up The Number)',
  ],
  'Not Lennon—McCartney': [
    'Blue Jay Way',
    'Christmas Time (Is Here Again)',
    'Cry For A Shadow',
    "Don't Bother Me",
    "Don't Pass Me By",
    'Flying',
    'For You Blue',
    'Free As A Bird',
    'Here Comes The Sun',
    'I Me Mine',
    'I Need You',
    'I Want To Tell You',
    'If I Needed Someone',
    'The Inner Light',
    "It's All Too Much",
    'Long, Long, Long',
    'Love You To',
    'Now And Then',
    "Octopus's Garden",
    'Old Brown Shoe',
    'Only A Northern Song',
    'Piggies',
    'Real Love',
    'Savoy Truffle',
    'Something',
    'Taxman',
    'Think For Yourself',
    'What Goes On',
    'While My Guitar Gently Weeps',
    'Within You Without You',
    'You Like Me Too Much',
    'Dig It',
  ],
  'George lead vocal': [
    'Blue Jay Way',
    'Do You Want To Know A Secret',
    "Don't Bother Me",
    'For You Blue',
    'Free As A Bird',
    'Here Comes The Sun',
    'I Me Mine',
    'I Need You',
    'I Want To Tell You',
    "I'm Happy Just To Dance With You",
    'If I Needed Someone',
    'The Inner Light',
    "It's All Too Much",
    'Long, Long, Long',
    'Love You To',
    'Old Brown Shoe',
    'Only A Northern Song',
    'Piggies',
    'Savoy Truffle',
    'Something',
    'Taxman',
    'Think For Yourself',
    'While My Guitar Gently Weeps',
    'Within You Without You',
    'You Like Me Too Much',
  ],
  'No percussion': [
    'Because',
    'Blackbird',
    'Eleanor Rigby',
    'Good Night',
    'Her Majesty',
    'Julia',
    'Revolution 9',
    "She's Leaving Home",
    'Yesterday',
  ],
  'George Martin plays piano': [
    "A Hard Day's Night",
    'Getting Better',
    'Good Day Sunshine',
    'In My Life',
    'Lovely Rita',
    'Misery',
    'No Reply',
    'Not A Second Time',
    'Rocky Raccoon',
    'Tell Me Why',
    "What You're Doing",
    'You Like Me Too Much',
  ],
  'Number(s) in title': [
    'Eight Days A Week',
    'For No One',
    'One After 909',
    'Revolution 1',
    'Revolution 9',
    'Two Of Us',
    "When I'm Sixty-Four",
  ],
  'Side A, Track 2': [
    "All I've Got To Do",
    'Dear Prudence',
    'Dig A Pony',
    'Eleanor Rigby',
    'I Call Your Name',
    'I Should Have Known Better',
    "I'm A Loser",
    'Misery',
    'Norwegian Wood (This Bird Has Flown)',
    'Only A Northern Song',
    'Something',
    'The Fool On The Hill',
    'The Night Before',
    'With A Little Help From My Friends',
    'Your Mother Should Know',
  ],
  'Side A, Track 3': [
    'Across The Universe',
    'All My Loving',
    'All Together Now',
    "Baby's In Black",
    'Flying',
    'Glass Onion',
    "I'm Only Sleeping",
    'If I Fell',
    'Lucy In The Sky With Diamonds',
    "Maxwell's Silver Hammer",
    "You Won't See Me",
    "You've Got To Hide Your Love Away",
  ],
  'Side A, Track 4': [
    'Blue Jay Way',
    "Don't Bother Me",
    'Getting Better',
    'Hey Bulldog',
    'I Me Mine',
    'I Need You',
    "I'm Happy Just To Dance With You",
    'Love You To',
    'Nowhere Man',
    'Ob-La-Di, Ob-La-Da',
    'Oh! Darling',
  ],
  'Side A, Track 5': [
    'And I Love Her',
    'Another Girl',
    'Dig It',
    'Fixing A Hole',
    'Here, There And Everywhere',
    "I'll Follow The Sun",
    "It's All Too Much",
    'Little Child',
    "Octopus's Garden",
    'Think For Yourself',
    'Wild Honey Pie',
    'Your Mother Should Know',
  ],
  'Under 2 minutes': [
    'Carry That Weight',
    'Dig It',
    'Do You Want To Know A Secret',
    'For No One',
    'From Me To You',
    'Golden Slumbers',
    'Her Majesty',
    'I Wanna Be Your Man',
    'I Will',
    "I'll Cry Instead",
    "I'll Follow The Sun",
    "I'm Happy Just To Dance With You",
    "It's Only Love",
    'Little Child',
    'Mean Mr Mustard',
    'Misery',
    'Polythene Pam',
    "Sgt Pepper's Lonely Hearts Club Band (Reprise)",
    'She Came In Through The Bathroom Window',
    "There's A Place",
    "Why Don't We Do It In The Road?",
    'Wild Honey Pie',
  ],
  'Released 1963': [
    'All My Loving',
    "All I've Got To Do",
    'Ask Me Why',
    'Do You Want To Know A Secret',
    "Don't Bother Me",
    'From Me To You',
    'Hold Me Tight',
    'I Saw Her Standing There',
    'I Wanna Be Your Man',
    'I Want To Hold Your Hand',
    "I'll Get You",
    "It Won't Be Long",
    'Little Child',
    'Misery',
    'Not A Second Time',
    'Please Please Me',
    'She Loves You',
    'Thank You Girl',
    "There's A Place",
    'This Boy',
  ],
  'Released 1964': [
    "A Hard Day's Night",
    'And I Love Her',
    'Any Time At All',
    "Baby's In Black",
    "Can't Buy Me Love",
    'Cry For A Shadow',
    'Eight Days A Week',
    'Every Little Thing',
    'I Call Your Name',
    "I Don't Want To Spoil The Party",
    'I Feel Fine',
    'I Should Have Known Better',
    "I'll Be Back",
    "I'll Cry Instead",
    "I'll Follow The Sun",
    "I'm A Loser",
    "I'm Happy Just To Dance With You",
    'If I Fell',
    'No Reply',
    "She's A Woman",
    'Tell Me Why',
    'Things We Said Today',
    "What You're Doing",
    "You Can't Do That",
  ],
  'Released 1965': [
    'Another Girl',
    'Day Tripper',
    'Drive My Car',
    'Girl',
    'Help!',
    'I Need You',
    "I'm Down",
    "I'm Looking Through You",
    "I've Just Seen A Face",
    'If I Needed Someone',
    'In My Life',
    "It's Only Love",
    'Michelle',
    'Norwegian Wood (This Bird Has Flown)',
    'Nowhere Man',
    'Run For Your Life',
    'Tell Me What You See',
    'The Night Before',
    'The Word',
    'Think For Yourself',
    'Ticket To Ride',
    'Wait',
    'We Can Work It Out',
    'What Goes On',
    'Yes It Is',
    'Yesterday',
    'You Like Me Too Much',
    "You Won't See Me",
    "You're Going To Lose That Girl",
    "You've Got To Hide Your Love Away",
  ],
  'Released 1966': [
    'And Your Bird Can Sing',
    'Doctor Robert',
    'Eleanor Rigby',
    'For No One',
    'Good Day Sunshine',
    'Got To Get You Into My Life',
    'Here, There And Everywhere',
    'I Want To Tell You',
    "I'm Only Sleeping",
    'Love You To',
    'Paperback Writer',
    'Rain',
    'She Said She Said',
    'Taxman',
    'Tomorrow Never Knows',
    'Yellow Submarine',
  ],
  'Released 1967': [
    'A Day In The Life',
    'All You Need Is Love',
    "Baby You're A Rich Man",
    'Being For The Benefit Of Mr Kite!',
    'Blue Jay Way',
    'Fixing A Hole',
    'Flying',
    'Getting Better',
    'Good Morning Good Morning',
    'Hello, Goodbye',
    'I Am The Walrus',
    'Lovely Rita',
    'Lucy In The Sky With Diamonds',
    'Magical Mystery Tour',
    'Penny Lane',
    "Sgt Pepper's Lonely Hearts Club Band",
    "Sgt Pepper's Lonely Hearts Club Band (Reprise)",
    "She's Leaving Home",
    'Strawberry Fields Forever',
    'The Fool On The Hill',
    "When I'm Sixty-Four",
    'With A Little Help From My Friends',
    'Within You Without You',
    'Your Mother Should Know',
    'Christmas Time (Is Here Again)',
  ],
  'Released 1968': [
    'Back In The USSR',
    'Birthday',
    'Blackbird',
    'Cry Baby Cry',
    'Dear Prudence',
    "Don't Pass Me By",
    "Everybody's Got Something To Hide Except Me And My Monkey",
    'Glass Onion',
    'Good Night',
    'Happiness Is A Warm Gun',
    'Helter Skelter',
    'Hey Jude',
    'Honey Pie',
    'I Will',
    "I'm So Tired",
    'Julia',
    'Lady Madonna',
    'Long, Long, Long',
    'Martha My Dear',
    "Mother Nature's Son",
    'Ob-La-Di, Ob-La-Da',
    'Piggies',
    'Revolution',
    'Revolution 1',
    'Revolution 9',
    'Rocky Raccoon',
    'Savoy Truffle',
    'Sexy Sadie',
    'The Continuing Story Of Bungalow Bill',
    'The Inner Light',
    'While My Guitar Gently Weeps',
    "Why Don't We Do It In The Road?",
    'Wild Honey Pie',
    'Yer Blues',
  ],
  'Released 1969': [
    'Across The Universe',
    'All Together Now',
    'Because',
    'Carry That Weight',
    'Come Together',
    "Don't Let Me Down",
    'Get Back',
    'Golden Slumbers',
    'Her Majesty',
    'Here Comes The Sun',
    'Hey Bulldog',
    "I Want You (She's So Heavy)",
    "It's All Too Much",
    "Maxwell's Silver Hammer",
    'Mean Mr Mustard',
    "Octopus's Garden",
    'Oh! Darling',
    'Old Brown Shoe',
    'Only A Northern Song',
    'Polythene Pam',
    'She Came In Through The Bathroom Window',
    'Something',
    'Sun King',
    'The Ballad Of John And Yoko',
    'The End',
    'You Never Give Me Your Money',
  ],
  'Released 1970': [
    'Dig A Pony',
    'Dig It',
    'For You Blue',
    'I Me Mine',
    "I've Got A Feeling",
    'Let It Be',
    'One After 909',
    'The Long And Winding Road',
    'Two Of Us',
    'You Know My Name (Look Up The Number)',
  ],
  'Songs with colours in lyrics': [
    'All Together Now',
    'And Your Bird Can Sing',
    'Ask Me Why',
    "Baby's In Black",
    'Because',
    'Blackbird',
    'Blue Jay Way',
    'Dear Prudence',
    'Golden Slumbers',
    'I Am The Walrus',
    'Lovely Rita',
    'Lucy In The Sky With Diamonds',
    "Maxwell's Silver Hammer",
    'Ob-La-Di, Ob-La-Da',
    'Old Brown Shoe',
    'Piggies',
    'Revolution 9',
    'Rocky Raccoon',
    'She Came In Through The Bathroom Window',
    'Tell Me What You See',
    'The Ballad Of John And Yoko',
    "There's A Place",
    "What You're Doing",
    'Yellow Submarine',
    'Yer Blues',
    'Yes It Is',
    "You Can't Do That",
    'You Never Give Me Your Money',
    'Thank You Girl',
    'Penny Lane',
    'Honey Pie',
    "I'll Get You",
    "Don't Pass Me By",
    'Only A Northern Song',
    "It's All Too Much",
    'For You Blue',
    "Baby You're A Rich Man",
  ],
  'Songs that mention real public figures by name': [
    'Dig It',
    'Glass Onion',
    'I Am The Walrus',
    "I'm So Tired",
    'Revolution',
    'Revolution 1',
    'Taxman',
    'The Ballad Of John And Yoko',
    'Two Of Us',
    'Yer Blues',
    'For You Blue',
    'Being For The Benefit Of Mr Kite!',
  ],
  'Songs with an Indian instrument': [
    'Across The Universe',
    'Getting Better',
    'Love You To',
    'Lucy In The Sky With Diamonds',
    'Norwegian Wood (This Bird Has Flown)',
    'Strawberry Fields Forever',
    'The Inner Light',
    'Tomorrow Never Knows',
    'Within You Without You',
  ],
  'Songs that begin with a count-in': [
    'Dig A Pony',
    'Get Back',
    'I Saw Her Standing There',
    "Sgt Pepper's Lonely Hearts Club Band",
    'Taxman',
    'Yer Blues',
    'Now And Then',
  ],
  'Paul plays the drums': [
    'Back In The USSR',
    'Dear Prudence',
    "Don't Pass Me By",
    'Martha My Dear',
    "Mother Nature's Son",
    'The Ballad Of John And Yoko',
  ],
  'Shares name with Beatle film': [
    "A Hard Day's Night",
    'Help!',
    'Let It Be',
    'Magical Mystery Tour',
    'Yellow Submarine',
  ],
  '2 word title': [
    'Another Girl',
    'Come Together',
    'Day Tripper',
    'Dear Prudence',
    'Dig It',
    'Doctor Robert',
    'Eleanor Rigby',
    'Get Back',
    'Getting Better',
    'Glass Onion',
    'Golden Slumbers',
    'Good Night',
    'Hello, Goodbye',
    'Helter Skelter',
    'Her Majesty',
    'Hey Bulldog',
    'Hey Jude',
    'Honey Pie',
    'I Will',
    "I'm Down",
    'Lady Madonna',
    'Little Child',
    'Lovely Rita',
    'No Reply',
    'Nowhere Man',
    "Octopus's Garden",
    'Oh! Darling',
    'Paperback Writer',
    'Penny Lane',
    'Polythene Pam',
    'Real Love',
    'Revolution 1',
    'Revolution 9',
    'Rocky Raccoon',
    'Savoy Truffle',
    'Sexy Sadie',
    'Sun King',
    'The End',
    'The Word',
    'This Boy',
    'Yellow Submarine',
    'Yer Blues',
  ],
  '3 word title': [
    'Across The Universe',
    'All My Loving',
    'All Together Now',
    'Ask Me Why',
    "Baby's In Black",
    'Blue Jay Way',
    'Carry That Weight',
    'Cry Baby Cry',
    'Dig A Pony',
    "Don't Bother Me",
    'Drive My Car',
    'Every Little Thing',
    'Fixing A Hole',
    'For No One',
    'For You Blue',
    'Good Day Sunshine',
    'Hold Me Tight',
    'I Feel Fine',
    'I Me Mine',
    "I'll Be Back",
    "I'll Cry Instead",
    "I'll Get You",
    "I'm A Loser",
    "I'm Only Sleeping",
    "I'm So Tired",
    'If I Fell',
    'In My Life',
    "It's Only Love",
    'Let It Be',
    'Long, Long, Long',
    'Love Me Do',
    'Love You To',
    'Magical Mystery Tour',
    'Martha My Dear',
    'Mean Mr Mustard',
    "Mother Nature's Son",
    'Now And Then',
    'Old Brown Shoe',
    'One After 909',
    'Please Please Me',
    'She Loves You',
    "She's A Woman",
    "She's Leaving Home",
    'Strawberry Fields Forever',
    'Tell Me Why',
    'Thank You Girl',
    'The Inner Light',
    'The Night Before',
    "There's A Place",
    'Think For Yourself',
    'Ticket To Ride',
    'Tomorrow Never Knows',
    'Two Of Us',
    'What Goes On',
    "What You're Doing",
    "When I'm Sixty-Four",
    'Wild Honey Pie',
    'Yes It Is',
    "Maxwell's Silver Hammer",
    'I Need You',
  ],
  '1 word title': [
    'Because',
    'Birthday',
    'Blackbird',
    'Flying',
    'Girl',
    'Help!',
    'Julia',
    'Michelle',
    'Misery',
    'Piggies',
    'Rain',
    'Revolution',
    'Something',
    'Taxman',
    'Wait',
    'Yesterday',
  ],
  "The Beatles aren't playing instruments": [
    'Eleanor Rigby',
    'Good Night',
    "She's Leaving Home",
    'The Inner Light',
  ],
  'Verb in the title': [
    "All I've Got To Do",
    'And Your Bird Can Sing',
    'Ask Me Why',
    'Being For The Benefit Of Mr Kite!',
    "Can't Buy Me Love",
    'Carry That Weight',
    'Come Together',
    'Cry Baby Cry',
    'Dig A Pony',
    'Dig It',
    'Do You Want To Know A Secret',
    "Don't Bother Me",
    "Don't Let Me Down",
    "Don't Pass Me By",
    'Drive My Car',
    "Everybody's Got Something To Hide Except Me And My Monkey",
    'Fixing A Hole',
    'Flying',
    'Get Back',
    'Getting Better',
    'Got To Get You Into My Life',
    'Happiness Is A Warm Gun',
    'Here Comes The Sun',
    'Hold Me Tight',
    'I Am The Walrus',
    'I Call Your Name',
    "I Don't Want To Spoil The Party",
    'I Feel Fine',
    'I Need You',
    'I Saw Her Standing There',
    'I Should Have Known Better',
    'I Wanna Be Your Man',
    'I Want To Hold Your Hand',
    'I Want To Tell You',
    "I Want You (She's So Heavy)",
    'I Will',
    "I'll Be Back",
    "I'll Cry Instead",
    "I'll Follow The Sun",
    "I'll Get You",
    "I'm A Loser",
    "I'm Down",
    "I'm Happy Just To Dance With You",
    "I'm Looking Through You",
    "I'm Only Sleeping",
    "I'm So Tired",
    "I've Got A Feeling",
    "I've Just Seen A Face",
    'If I Fell',
    'If I Needed Someone',
    "It's All Too Much",
    "It's Only Love",
    'Let It Be',
    'Love Me Do',
    'Love You To',
    'Norwegian Wood (This Bird Has Flown)',
    'Please Please Me',
    'PS I Love You',
    'Run For Your Life',
    'She Came In Through The Bathroom Window',
    'She Loves You',
    'She Said She Said',
    "She's A Woman",
    "She's Leaving Home",
    'Tell Me What You See',
    'Tell Me Why',
    'Thank You Girl',
    "There's A Place",
    'Things We Said Today',
    'Think For Yourself',
    'Ticket To Ride',
    'Tomorrow Never Knows',
    'Wait',
    'We Can Work It Out',
    'What Goes On',
    "What You're Doing",
    'When I Get Home',
    "When I'm Sixty-Four",
    'While My Guitar Gently Weeps',
    "Why Don't We Do It In The Road?",
    'Yes It Is',
    "You Can't Do That",
    'You Know My Name (Look Up The Number)',
    'You Like Me Too Much',
    'You Never Give Me Your Money',
    "You Won't See Me",
    "You're Going To Lose That Girl",
    "You've Got To Hide Your Love Away",
    'Your Mother Should Know',
    'Help!',
    'All You Need Is Love',
    "Baby You're A Rich Man",
    'Cry For A Shadow',
  ],
  'More than one time signature': [
    'Across The Universe',
    'All You Need Is Love',
    'Blackbird',
    'Good Morning Good Morning',
    'Happiness Is A Warm Gun',
    'Here Comes The Sun',
    'I Me Mine',
    "I Want You (She's So Heavy)",
    'Love You To',
    'Lucy In The Sky With Diamonds',
    'Martha My Dear',
    'She Said She Said',
    'Strawberry Fields Forever',
    'The Continuing Story Of Bungalow Bill',
    'Two Of Us',
    'We Can Work It Out',
    'Within You Without You',
    'Mean Mr Mustard',
    'Being For The Benefit Of Mr Kite!',
    'Back In The USSR',
  ],
  '“You” in the title': [
    'All You Need Is Love',
    'Do You Want To Know A Secret',
    'For You Blue',
    'From Me To You',
    'Got To Get You Into My Life',
    'I Need You',
    'I Want To Tell You',
    "I Want You (She's So Heavy)",
    "I'll Get You",
    "I'm Happy Just To Dance With You",
    "I'm Looking Through You",
    'Love You To',
    'PS I Love You',
    'She Loves You',
    'Tell Me What You See',
    'Thank You Girl',
    'Within You Without You',
    "You Can't Do That",
    'You Know My Name (Look Up The Number)',
    'You Like Me Too Much',
    'You Never Give Me Your Money',
    "You Won't See Me",
  ],
  'Word(s) repeat in title': [
    'Cry Baby Cry',
    'Good Morning Good Morning',
    'Long, Long, Long',
    'Please Please Me',
    'She Said She Said',
    'Within You Without You',
  ],
  '“Love”, “Loving”, “Loves” in the title': [
    'All My Loving',
    'All You Need Is Love',
    'And I Love Her',
    "Can't Buy Me Love",
    "It's Only Love",
    'Love Me Do',
    'Love You To',
    'Lovely Rita',
    'PS I Love You',
    'Real Love',
    'She Loves You',
    "You've Got To Hide Your Love Away",
  ],
  'Peaked at 2 in UK singles chart': [
    'Free As A Bird',
    'Let It Be',
    'Penny Lane',
    'Please Please Me',
    'Strawberry Fields Forever',
  ],
  'Features brass instruments': [
    'A Day In The Life',
    'Across The Universe',
    'All You Need Is Love',
    'Carry That Weight',
    'For No One',
    'Golden Slumbers',
    'Good Morning Good Morning',
    'Good Night',
    'Got To Get You Into My Life',
    'Hey Jude',
    'Honey Pie',
    'I Am The Walrus',
    'I Me Mine',
    "It's All Too Much",
    'Lady Madonna',
    'Let It Be',
    'Magical Mystery Tour',
    'Martha My Dear',
    "Mother Nature's Son",
    'Ob-La-Di, Ob-La-Da',
    'Only A Northern Song',
    'Penny Lane',
    'Revolution 1',
    'Savoy Truffle',
    "Sgt Pepper's Lonely Hearts Club Band",
    'Strawberry Fields Forever',
    'The End',
    'The Long And Winding Road',
    'Yellow Submarine',
  ],
  'Cover version by another artist got into the UK singles chart top 10': [
    'Dear Prudence',
    'Help!',
    'I Saw Her Standing There',
    'I Want To Hold Your Hand',
    "I'm Only Sleeping",
    'Let It Be',
    'Lucy In The Sky With Diamonds',
    'Michelle',
    'Ob-La-Di, Ob-La-Da',
    'Real Love',
    "She's Leaving Home",
    'Something',
    'Strawberry Fields Forever',
    'The Long And Winding Road',
    'With A Little Help From My Friends',
    'Do You Want To Know A Secret',
  ],
  'The Beatles played it on tour or in a live performance': [
    "A Hard Day's Night",
    'All My Loving',
    'All You Need Is Love',
    'And I Love Her',
    'Ask Me Why',
    "Baby's In Black",
    "Can't Buy Me Love",
    'Day Tripper',
    'Dig A Pony',
    'Do You Want To Know A Secret',
    "Don't Let Me Down",
    'Eight Days A Week',
    'From Me To You',
    'Get Back',
    'Help!',
    'Hey Jude',
    'I Call Your Name',
    'I Feel Fine',
    'I Saw Her Standing There',
    'I Should Have Known Better',
    'I Wanna Be Your Man',
    'I Want To Hold Your Hand',
    "I'll Follow The Sun",
    "I'll Get You",
    "I'm A Loser",
    "I'm Down",
    "I'm Happy Just To Dance With You",
    "I've Got A Feeling",
    'If I Fell',
    'If I Needed Someone',
    "It Won't Be Long",
    'Love Me Do',
    'Misery',
    'Nowhere Man',
    'One After 909',
    'Paperback Writer',
    'Please Please Me',
    'PS I Love You',
    'Rain',
    'Revolution',
    'She Loves You',
    "She's A Woman",
    'Tell Me Why',
    'Thank You Girl',
    'The Night Before',
    "There's A Place",
    'Things We Said Today',
    'This Boy',
    'Ticket To Ride',
    'We Can Work It Out',
    "When I'm Sixty-Four",
    'Yes It Is',
    'Yesterday',
    "You Can't Do That",
  ],
  'Real place named in lyrics': [
    'A Day In The Life',
    'Back In The USSR',
    'Blue Jay Way',
    'Cry Baby Cry',
    'Get Back',
    'Glass Onion',
    'Honey Pie',
    'I Am The Walrus',
    'Penny Lane',
    'Rocky Raccoon',
    'Savoy Truffle',
    'Strawberry Fields Forever',
    'The Ballad Of John And Yoko',
    "When I'm Sixty-Four",
    'Being For The Benefit Of Mr Kite!',
  ],
  'Food / meals / drink in lyrics': [
    'A Day In The Life',
    'All Together Now',
    'Come Together',
    'Cry Baby Cry',
    'Doctor Robert',
    'Drive My Car',
    'Eleanor Rigby',
    'Glass Onion',
    'Good Morning Good Morning',
    'Happiness Is A Warm Gun',
    'Her Majesty',
    'I Am The Walrus',
    "I Don't Want To Spoil The Party",
    'I Me Mine',
    "I'm So Tired",
    "It's All Too Much",
    'Lovely Rita',
    'Lucy In The Sky With Diamonds',
    'Norwegian Wood (This Bird Has Flown)',
    'Penny Lane',
    'Piggies',
    'Rain',
    'Revolution 9',
    'Rocky Raccoon',
    'Savoy Truffle',
    'Strawberry Fields Forever',
    "When I'm Sixty-Four",
    'Honey Pie',
    'Wild Honey Pie',
    'The Ballad Of John And Yoko',
    'Two Of Us',
  ],
  'Not about love/not about romantic relationships': [
    'A Day In The Life',
    'Across The Universe',
    'All Together Now',
    'Back In The USSR',
    'Because',
    'Being For The Benefit Of Mr Kite!',
    'Birthday',
    'Blackbird',
    'Carry That Weight',
    'Christmas Time (Is Here Again)',
    'Come Together',
    'Cry Baby Cry',
    'Dear Prudence',
    'Dig A Pony',
    'Dig It',
    'Doctor Robert',
    'Eleanor Rigby',
    "Everybody's Got Something To Hide Except Me And My Monkey",
    'Fixing A Hole',
    'Free As A Bird',
    'Get Back',
    'Getting Better',
    'Glass Onion',
    'Golden Slumbers',
    'Good Morning Good Morning',
    'Good Night',
    'Happiness Is A Warm Gun',
    'Hello, Goodbye',
    'Here Comes The Sun',
    'Hey Bulldog',
    'Hey Jude',
    'I Am The Walrus',
    "I'm Only Sleeping",
    "I'm So Tired",
    'Julia',
    'Lady Madonna',
    'Let It Be',
    'Lucy In The Sky With Diamonds',
    'Magical Mystery Tour',
    "Maxwell's Silver Hammer",
    'Mean Mr Mustard',
    "Mother Nature's Son",
    'Nowhere Man',
    "Octopus's Garden",
    'Only A Northern Song',
    'Paperback Writer',
    'Piggies',
    'Rain',
    'Revolution',
    'Revolution 1',
    'Revolution 9',
    'Savoy Truffle',
    "Sgt Pepper's Lonely Hearts Club Band",
    "Sgt Pepper's Lonely Hearts Club Band (Reprise)",
    'She Said She Said',
    "She's Leaving Home",
    'Strawberry Fields Forever',
    'Sun King',
    'Taxman',
    'The Continuing Story Of Bungalow Bill',
    'The Fool On The Hill',
    'The Inner Light',
    'Tomorrow Never Knows',
    'While My Guitar Gently Weeps',
    'With A Little Help From My Friends',
    'Within You Without You',
    'Yellow Submarine',
    'Yer Blues',
    'Your Mother Should Know',
    'I Me Mine',
    'Flying',
    'Penny Lane',
    'Blue Jay Way',
  ],
  'Animal in lyrics': [
    'And Your Bird Can Sing',
    'Being For The Benefit Of Mr Kite!',
    'Blackbird',
    'Blue Jay Way',
    'Come Together',
    'Cry Baby Cry',
    'Dear Prudence',
    'Dig A Pony',
    "Everybody's Got Something To Hide Except Me And My Monkey",
    'For You Blue',
    'Free As A Bird',
    'Glass Onion',
    'Happiness Is A Warm Gun',
    'Hey Bulldog',
    'I Am The Walrus',
    'Lucy In The Sky With Diamonds',
    'Norwegian Wood (This Bird Has Flown)',
    "Octopus's Garden",
    'Piggies',
    'Revolution 9',
    'Rocky Raccoon',
    'The Continuing Story Of Bungalow Bill',
    'When I Get Home',
    'Yer Blues',
  ],
  'Appears on Meet  The Beatles! (album in North America)': [
    "All I've Got To Do",
    'All My Loving',
    "Don't Bother Me",
    'Hold Me Tight',
    'I Saw Her Standing There',
    'I Wanna Be Your Man',
    'I Want To Hold Your Hand',
    "It Won't Be Long",
    'Little Child',
    'Not A Second Time',
    'This Boy',
  ],
  'Appears on Yesterday and Today (album in North America)': [
    'And Your Bird Can Sing',
    'Day Tripper',
    'Doctor Robert',
    'Drive My Car',
    "I'm Only Sleeping",
    'If I Needed Someone',
    'Nowhere Man',
    'We Can Work It Out',
    'What Goes On',
    'Yesterday',
  ],
  'Jewellery or items of clothing in lyrics': [
    'A Day In The Life',
    "Can't Buy Me Love",
    'Come Together',
    'Eleanor Rigby',
    'Get Back',
    'Good Morning Good Morning',
    'Happiness Is A Warm Gun',
    'I Am The Walrus',
    'I Feel Fine',
    "I'm Down",
    "I've Got A Feeling",
    'Lady Madonna',
    'Lovely Rita',
    'Lucy In The Sky With Diamonds',
    'Ob-La-Di, Ob-La-Da',
    'Old Brown Shoe',
    'Penny Lane',
    'Piggies',
    'Polythene Pam',
    "She's Leaving Home",
    'The Ballad Of John And Yoko',
    'Two Of Us',
    "When I'm Sixty-Four",
  ],
  'A-Side of a UK single (1962-1970) that also appears on a UK studio album': [
    "A Hard Day's Night",
    'All You Need Is Love',
    "Can't Buy Me Love",
    'Come Together',
    'Eleanor Rigby',
    'Get Back',
    'Help!',
    'Let It Be',
    'Love Me Do',
    'Please Please Me',
    'Something',
    'Ticket To Ride',
    'Yellow Submarine',
  ],
  'Weather mentioned in lyrics': [
    'Across The Universe',
    'Any Time At All',
    'Because',
    'Blue Jay Way',
    'Dear Prudence',
    'Dig A Pony',
    'Fixing A Hole',
    'Good Day Sunshine',
    'Here Comes The Sun',
    'Hey Bulldog',
    'Honey Pie',
    "I'll Follow The Sun",
    "I'm A Loser",
    "I've Got A Feeling",
    'Julia',
    'Let It Be',
    'Lucy In The Sky With Diamonds',
    "Mother Nature's Son",
    "Octopus's Garden",
    'Penny Lane',
    'Please Please Me',
    'Rain',
    'Sexy Sadie',
    'Sun King',
    'Tell Me What You See',
    'The Ballad Of John And Yoko',
    'The Long And Winding Road',
    'The Word',
    'Two Of Us',
    'Yer Blues',
    'I Am The Walrus',
  ],
  "In Rolling Stone's 500 Greatest Songs of All Time list, 2004 version": [
    'A Day In The Life',
    "A Hard Day's Night",
    'All You Need Is Love',
    "Can't Buy Me Love",
    'Come Together',
    'Eleanor Rigby',
    'Help!',
    'Hey Jude',
    'I Saw Her Standing There',
    'I Want To Hold Your Hand',
    'In My Life',
    'Let It Be',
    'Norwegian Wood (This Bird Has Flown)',
    'Penny Lane',
    'Please Please Me',
    'Rain',
    'She Loves You',
    'Something',
    'Strawberry Fields Forever',
    'Ticket To Ride',
    'While My Guitar Gently Weeps',
    'With A Little Help From My Friends',
    'Yesterday',
  ],
  'Features a harmonica': [
    'All Together Now',
    'Being For The Benefit Of Mr Kite!',
    'From Me To You',
    'I Should Have Known Better',
    "I'll Get You",
    "I'm A Loser",
    'Little Child',
    'Love Me Do',
    'Please Please Me',
    'Rocky Raccoon',
    'Thank You Girl',
    'The Fool On The Hill',
    "There's A Place",
    'You Know My Name (Look Up The Number)',
  ],
  'The word "baby" or "babe" in the lyrics': [
    "Baby You're A Rich Man",
    "Baby's In Black",
    'Cry Baby Cry',
    'Drive My Car',
    'Eight Days A Week',
    'For You Blue',
    'I Feel Fine',
    'I Wanna Be Your Man',
    "I Want You (She's So Heavy)",
    "I'm Down",
    "I'm Looking Through You",
    'Lady Madonna',
    'Little Child',
    'Old Brown Shoe',
    'One After 909',
    'Run For Your Life',
    "She's Leaving Home",
    'Ticket To Ride',
    'When I Get Home',
    'Yes It Is',
    'You Know My Name (Look Up The Number)',
  ],
  'Days of the week in the lyrics': [
    'Being For The Benefit Of Mr Kite!',
    'Day Tripper',
    'I Am The Walrus',
    'Lady Madonna',
    'She Came In Through The Bathroom Window',
    "She's Leaving Home",
    'Two Of Us',
    "When I'm Sixty-Four",
    'You Never Give Me Your Money',
  ],
  'Lyrics that refer to the telephone': [
    "All I've Got To Do",
    'Any Time At All',
    'Back In The USSR',
    'Doctor Robert',
    "I'm So Tired",
    'If I Needed Someone',
    "Maxwell's Silver Hammer",
    'No Reply',
    'She Came In Through The Bathroom Window',
    'The Ballad Of John And Yoko',
    "You Won't See Me",
    'You Know My Name (Look Up The Number)',
  ],
  '"Heart" in the lyrics': [
    'Drive My Car',
    'Hey Jude',
    'I Saw Her Standing There',
    'I Will',
    "I'll Be Back",
    "I'll Cry Instead",
    'If I Fell',
    'Julia',
    'Let It Be',
    'Lovely Rita',
    'Please Please Me',
    'Real Love',
    'Savoy Truffle',
    "Sgt Pepper's Lonely Hearts Club Band",
    "Sgt Pepper's Lonely Hearts Club Band (Reprise)",
    'Tell Me What You See',
    'Wait',
    'What Goes On',
    'Your Mother Should Know',
    'From Me To You',
  ],
  'The words "head(s)", "shoulder(s)", "knee(s)" or "toe(s)" in lyrics': [
    'A Day In The Life',
    'Any Time At All',
    'Back In The USSR',
    'Being For The Benefit Of Mr Kite!',
    'Come Together',
    'For No One',
    'Getting Better',
    'Hey Jude',
    'Honey Pie',
    'I Want To Tell You',
    "I'll Cry Instead",
    "I'm Only Sleeping",
    "I've Got A Feeling",
    'Lady Madonna',
    'Lovely Rita',
    'Lucy In The Sky With Diamonds',
    'Martha My Dear',
    "Maxwell's Silver Hammer",
    "Octopus's Garden",
    'One After 909',
    'Penny Lane',
    'Rain',
    'Revolution',
    'Revolution 1',
    'Run For Your Life',
    'Savoy Truffle',
    'She Said She Said',
    'Tell Me Why',
    'The Ballad Of John And Yoko',
    'The Continuing Story Of Bungalow Bill',
    'The Fool On The Hill',
    "There's A Place",
    "When I'm Sixty-Four",
    "You've Got To Hide Your Love Away",
  ],
  'Billy Preston plays on it': [
    "Don't Let Me Down",
    'Something',
    'Oh! Darling',
    "I Want You (She's So Heavy)",
    'Dig A Pony',
    'Dig It',
    'Let It Be',
    "I've Got A Feeling",
    'One After 909',
    'Get Back',
  ],
  'All four Beatles (and no one else) on the recording': [
    "All I've Got To Do",
    'All My Loving',
    'All Together Now',
    'And I Love Her',
    'And Your Bird Can Sing',
    'Another Girl',
    'Any Time At All',
    'Ask Me Why',
    "Baby's In Black",
    'Come Together',
    'Day Tripper',
    'Do You Want To Know A Secret',
    'Doctor Robert',
    "Don't Bother Me",
    'Drive My Car',
    'Eight Days A Week',
    'Every Little Thing',
    "Everybody's Got Something To Hide Except Me And My Monkey",
    'Flying',
    'For You Blue',
    'From Me To You',
    'Girl',
    'Happiness Is A Warm Gun',
    'Help!',
    'Here, There And Everywhere',
    'Hey Bulldog',
    'Hold Me Tight',
    'I Call Your Name',
    "I Don't Want To Spoil The Party",
    'I Feel Fine',
    'I Need You',
    'I Saw Her Standing There',
    'I Should Have Known Better',
    'I Want To Hold Your Hand',
    'I Want To Tell You',
    "I'll Be Back",
    "I'll Cry Instead",
    "I'll Follow The Sun",
    "I'll Get You",
    "I'm A Loser",
    "I'm Down",
    "I'm Happy Just To Dance With You",
    "I'm Looking Through You",
    "I'm Only Sleeping",
    "I'm So Tired",
    "I've Just Seen A Face",
    'If I Fell',
    'If I Needed Someone',
    "It Won't Be Long",
    "It's Only Love",
    'Little Child',
    'Lucy In The Sky With Diamonds',
    'Mean Mr Mustard',
    'Michelle',
    'Norwegian Wood (This Bird Has Flown)',
    'Nowhere Man',
    "Octopus's Garden",
    'Old Brown Shoe',
    'Only A Northern Song',
    'Paperback Writer',
    'Polythene Pam',
    'Rain',
    'Run For Your Life',
    'Sexy Sadie',
    'She Came In Through The Bathroom Window',
    'She Loves You',
    "She's A Woman",
    'Taxman',
    'Tell Me What You See',
    'Thank You Girl',
    'The Night Before',
    "There's A Place",
    'Things We Said Today',
    'Think For Yourself',
    'This Boy',
    'Ticket To Ride',
    'Two Of Us',
    'Wait',
    'We Can Work It Out',
    'What Goes On',
    "What You're Doing",
    'When I Get Home',
    'Yer Blues',
    "You Can't Do That",
    'You Never Give Me Your Money',
    "You're Going To Lose That Girl",
    'Your Mother Should Know',
    'Please Please Me',
  ],
  'Body of water in the lyrics': [
    'Glass Onion',
    'Honey Pie',
    "I'm Only Sleeping",
    "It's All Too Much",
    'Julia',
    'Lucy In The Sky With Diamonds',
    "Mother Nature's Son",
    "Octopus's Garden",
    'Tomorrow Never Knows',
    'The Long And Winding Road',
    'Yellow Submarine',
    'Across The Universe',
  ],
  "The full song title isn't in the lyrics": [
    'A Day In The Life',
    'Flying',
    "I Want You (She's So Heavy)",
    'Love You To',
    'Norwegian Wood (This Bird Has Flown)',
    'Revolution 1',
    'Revolution 9',
    "Sgt Pepper's Lonely Hearts Club Band (Reprise)",
    'The Ballad Of John And Yoko',
    'The Continuing Story Of Bungalow Bill',
    'The Inner Light',
    'Tomorrow Never Knows',
    'Wild Honey Pie',
    'Within You Without You',
    'Yer Blues',
    "Everybody's Got Something To Hide Except Me And My Monkey",
    'Being For The Benefit Of Mr Kite!',
    'For You Blue',
    'Cry For A Shadow',
  ],
  'Features orchestral strings': [
    'A Day In The Life',
    'Across The Universe',
    'All You Need Is Love',
    'Blue Jay Way',
    'Carry That Weight',
    "Don't Pass Me By",
    'Eleanor Rigby',
    'Glass Onion',
    'Golden Slumbers',
    'Good Night',
    'Hello, Goodbye',
    'Here Comes The Sun',
    'Hey Jude',
    'I Am The Walrus',
    'I Me Mine',
    'Let It Be',
    'Martha My Dear',
    'Now And Then',
    'Piggies',
    "She's Leaving Home",
    'Something',
    'Strawberry Fields Forever',
    'The End',
    'The Long And Winding Road',
    'Within You Without You',
    'Yesterday',
  ],
  'The word "boy" in the lyrics': [
    'A Day In The Life',
    'Back In The USSR',
    'Carry That Weight',
    "Maxwell's Silver Hammer",
    'I Am The Walrus',
    "Mother Nature's Son",
    "Octopus's Garden",
    'Real Love',
    'Rocky Raccoon',
    'She Said She Said',
    "She's A Woman",
    'The Ballad Of John And Yoko',
    'This Boy',
    "You Can't Do That",
    'Good Morning Good Morning',
  ],
  'The word "girl" in the lyrics': [
    'Another Girl',
    'Back In The USSR',
    "Don't Bother Me",
    'Drive My Car',
    'Eight Days A Week',
    'For You Blue',
    'Get Back',
    'Girl',
    'Happiness Is A Warm Gun',
    'Her Majesty',
    'Honey Pie',
    'I Am The Walrus',
    'I Feel Fine',
    'I Should Have Known Better',
    "I'll Cry Instead",
    "I'm A Loser",
    "I've Just Seen A Face",
    "It's Only Love",
    'Lucy In The Sky With Diamonds',
    'Martha My Dear',
    'Norwegian Wood (This Bird Has Flown)',
    'Ob-La-Di, Ob-La-Da',
    "Octopus's Garden",
    'Old Brown Shoe',
    'Please Please Me',
    'Polythene Pam',
    'Real Love',
    'Rocky Raccoon',
    'Run For Your Life',
    'Thank You Girl',
    'Things We Said Today',
    'Ticket To Ride',
    'What Goes On',
    "What You're Doing",
    'When I Get Home',
    'Yer Blues',
    "You Won't See Me",
    "You're Going To Lose That Girl",
  ],
  'The word "face" in the lyrics': [
    'A Day In The Life',
    'Eleanor Rigby',
    'Here Comes The Sun',
    'I Am The Walrus',
    "I'm Happy Just To Dance With You",
    "I've Just Seen A Face",
    'No Reply',
    'Ob-La-Di, Ob-La-Da',
    "You Can't Do That",
    "You've Got To Hide Your Love Away",
  ],
  'The word "eye(s)" in the lyrics': [
    'Across The Universe',
    'All My Loving',
    'Any Time At All',
    "Baby You're A Rich Man",
    'Blackbird',
    'Come Together',
    'Dear Prudence',
    'For No One',
    'Golden Slumbers',
    'Good Night',
    'Happiness Is A Warm Gun',
    'I Am The Walrus',
    'I Need You',
    "I'm Only Sleeping",
    "It Won't Be Long",
    "It's All Too Much",
    'Julia',
    'Lucy In The Sky With Diamonds',
    'Penny Lane',
    'Piggies',
    'Rocky Raccoon',
    "She's A Woman",
    'Strawberry Fields Forever',
    'Taxman',
    'Tell Me What You See',
    'Tell Me Why',
    'The Continuing Story Of Bungalow Bill',
    'The Fool On The Hill',
    'The Night Before',
    'Think For Yourself',
    'Yer Blues',
    'Here, There And Everywhere',
  ],
  'Features either a mellotron or a synthesiser': [
    "Baby You're A Rich Man",
    'Because',
    'Flying',
    'Here Comes The Sun',
    "I Want You (She's So Heavy)",
    "Maxwell's Silver Hammer",
    "Octopus's Garden",
    'Strawberry Fields Forever',
    'The Continuing Story Of Bungalow Bill',
    'Tomorrow Never Knows',
  ],
  'Features either a harmonium or a harpsichord/clavichord': [
    'All You Need Is Love',
    'Because',
    'Being For The Benefit Of Mr Kite!',
    'Cry Baby Cry',
    'Doctor Robert',
    'Fixing A Hole',
    'For No One',
    'Here Comes The Sun',
    'If I Needed Someone',
    'Penny Lane',
    'Piggies',
    'Rocky Raccoon',
    'Sun King',
    'We Can Work It Out',
  ],
  'The word "song(s)" in the lyrics': [
    'Hey Jude',
    'Honey Pie',
    'I Will',
    'Julia',
    'Love You To',
    "Mother Nature's Son",
    'Only A Northern Song',
    'Your Mother Should Know',
    "Sgt Pepper's Lonely Hearts Club Band",
    'With A Little Help From My Friends',
  ],
  'The word "money" in the lyrics': [
    "A Hard Day's Night",
    "Baby You're A Rich Man",
    "Can't Buy Me Love",
    'Doctor Robert',
    'Lady Madonna',
    'Revolution',
    'Revolution 1',
    "She's Leaving Home",
    'The Ballad Of John And Yoko',
    'You Never Give Me Your Money',
  ],
  'The word "mother" in the lyrics': [
    'Cry Baby Cry',
    'Happiness Is A Warm Gun',
    'Let It Be',
    "Mother Nature's Son",
    'The Continuing Story Of Bungalow Bill',
    'Yer Blues',
    'Your Mother Should Know',
  ],
  'Modes of transport referred to in the lyrics': [
    'Lucy In The Sky With Diamonds',
    'Drive My Car',
    'Penny Lane',
    "Don't Pass Me By",
    "I've Got A Feeling",
    'One After 909',
    'A Day In The Life',
    'Dig A Pony',
    'Honey Pie',
    'All Together Now',
    'The Ballad Of John And Yoko',
    'Back In The USSR',
    'Taxman',
    'Ob-La-Di, Ob-La-Da',
    "She's Leaving Home",
  ],
  'Number 1 in the US (Billboard Hot 100) but never number 1 in the UK singles chart':
    [
      'Love Me Do',
      'Eight Days A Week',
      'Yesterday',
      'Penny Lane',
      'Something',
      'Let It Be',
      'The Long And Winding Road',
    ],
  'Opens Side Two on a UK studio album': [
    'Love Me Do',
    'Any Time At All',
    'Eight Days A Week',
    'What Goes On',
    'Good Day Sunshine',
    'Within You Without You',
    'Martha My Dear',
    'Here Comes The Sun',
    "I've Got A Feeling",
  ],
  'John and Paul both singing lead vocals': [
    'A Day In The Life',
    "A Hard Day's Night",
    'All Together Now',
    "Baby's In Black",
    'Because',
    'Birthday',
    'Christmas Time (Is Here Again)',
    'Cry Baby Cry',
    'Day Tripper',
    'Drive My Car',
    'Eight Days A Week',
    'Every Little Thing',
    'Free As A Bird',
    'From Me To You',
    'I Feel Fine',
    'I Want To Hold Your Hand',
    "I'll Get You",
    "I've Got A Feeling",
    'If I Fell',
    'Little Child',
    'Love Me Do',
    'Magical Mystery Tour',
    'Misery',
    'One After 909',
    "Sgt Pepper's Lonely Hearts Club Band",
    "Sgt Pepper's Lonely Hearts Club Band (Reprise)",
    'She Loves You',
    "She's Leaving Home",
    'Tell Me What You See',
    'Thank You Girl',
    'The Word',
    "There's A Place",
    'This Boy',
    'Two Of Us',
    'Wait',
    'We Can Work It Out',
    'You Know My Name (Look Up The Number)',
  ],
  'Wings played it live on tour': [
    'Yesterday',
    'The Long And Winding Road',
    'Lady Madonna',
    "I've Just Seen A Face",
    'Blackbird',
    'Got To Get You Into My Life',
    'The Fool On The Hill',
    'Let It Be',
  ],
};
